// Generated by BUCKLESCRIPT VERSION 1.9.3, PLEASE EDIT WITH CARE
'use strict';

var App            = require("./app");
var React          = require("react");
var ReactDOMRe     = require("reason-react/lib/js/src/reactDOMRe.js");
var ReasonReact    = require("reason-react/lib/js/src/reasonReact.js");
var VideoPlayer    = require("./videoPlayer");
var CreateReactApp = require("./createReactApp");

((require('./index.css')));

var logo_precisioneffect = (require('./img/logos/precisioneffect.png'));

var logo_reason = (require('./img/logos/reason.png'));

var maintainability = (require('./img/maintainability.jpg'));

var logo_react = (require('./img/logos/react.svg'));

var logo_redux = (require('./img/logos/redux.png'));

var logo_flow = (require('./img/logos/flow.png'));

var why = (require('./img/why.gif'));

var reach = (require('./img/reach.jpg'));

var bucklescript = (require('./img/bucklescript.png'));

var logo_reasonreact = (require('./img/logos/reason-react-white.svg'));

var converted = (require('./img/converted.png'));

var interop = (require('./img/interop.png'));

var moment = (require('./img/types/moment.jpg'));

var naive = (require('./img/types/naive.png'));

var head = (require('./img/types/head.png'));

var pairs = (require('./img/types/pairs.png'));

var win = (require('./img/types/win.jpg'));

var bsb = (require('./img/environment/bsb.png'));

var options = (require('./img/environment/options.png'));

var editor = (require('./img/environment/editor.png'));

var cra = (require('./img/createReactApp/code.png'));

var cra_css = (require('./img/createReactApp/css.png'));

var cra_logo = (require('./img/createReactApp/logo.png'));

var cra_component = (require('./img/createReactApp/component.png'));

var cra_make = (require('./img/createReactApp/make.png'));

var cra_render = (require('./img/createReactApp/render.png'));

var cra_string = (require('./img/createReactApp/string.png'));

var vp_action_state_component = (require('./img/videoPlayer/action-state-component.png'));

var vp_ref = (require('./img/videoPlayer/ref.png'));

var vp_make = (require('./img/videoPlayer/make.png'));

var vp_initialState = (require('./img/videoPlayer/initialState.png'));

var vp_reducer = (require('./img/videoPlayer/reducer.png'));

var vp_reducer_switch = (require('./img/videoPlayer/reducer-switch.png'));

var vp_reducer_if = (require('./img/videoPlayer/reducer-if.png'));

var vp_reducer_ref = (require('./img/videoPlayer/reducer-ref.png'));

var vp_reducer_state = (require('./img/videoPlayer/reducer-state.png'));

var vp_render = (require('./img/videoPlayer/render.png'));

var vp_action_ref = (require('./img/videoPlayer/action-ref.png'));

var retained = (require('./img/retained/full.png'));

var retained_type = (require('./img/retained/type.png'));

var retained_component = (require('./img/retained/component.png'));

var retained_prop = (require('./img/retained/prop.png'));

var retained_didMount = (require('./img/retained/didMount.png'));

var reducer_options = (require('./img/reducer-options.png'));

var medium = (require('./img/medium.png'));

var config = /* record */[
  /* width */1024,
  /* height */768,
  /* perspective */1000,
  /* transitionDuration */1000
];

function s(prim) {
  return prim;
}

var slides = /* array */[
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */-2000,
        /* y */-1500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */0
      ],
      /* scale */1.0
    ],
    React.createElement("div", {
          style: {
            display: "flex",
            height: "40%",
            flexDirection: "column"
          }
        }, React.createElement("h1", undefined, "From ReactJS to ReasonML"), React.createElement("a", {
              style: {
                marginTop: "auto"
              },
              href: "https://persianturtle.github.io/reasonml-talk-slides/build/"
            }, "https://persianturtle.github.io/reasonml-talk-slides/build/"))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */-1000,
        /* y */-1500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */0
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "About me"), React.createElement("p", {
              style: {
                margin: "0"
              }
            }, "Raphael Rafatpanah"), React.createElement("div", {
              style: {
                display: "flex",
                alignItems: "center"
              }
            }, React.createElement("p", {
                  style: {
                    margin: "0"
                  }
                }, "UI Architect @ "), React.createElement("a", {
                  style: {
                    display: "flex",
                    alignItems: "center"
                  },
                  href: "https://precisioneffect.com",
                  target: "_blank"
                }, React.createElement("img", {
                      style: {
                        marginLeft: "7px",
                        width: "210px"
                      },
                      src: logo_precisioneffect
                    }))), React.createElement("a", {
              href: "https://github.com/persianturtle",
              target: "_blank"
            }, React.createElement("p", {
                  style: {
                    margin: "0"
                  }
                }, "github.com/persianturtle")), React.createElement("a", {
              href: "https://medium.com/@rrafatpanah",
              target: "_blank"
            }, React.createElement("p", {
                  style: {
                    margin: "0"
                  }
                }, "medium.com/@rrafatpanah")), React.createElement("a", {
              href: "https://twitter.com/rrafatpanah",
              target: "_blank"
            }, React.createElement("p", {
                  style: {
                    margin: "0"
                  }
                }, "twitter: @rrafatpanah")))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */0,
        /* y */-2500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */0
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          src: logo_reason
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */1000,
        /* y */-2500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */0
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "80%"
          },
          src: maintainability
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */2000,
        /* y */-1500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */90
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "80%"
          },
          src: logo_react
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */2000,
        /* y */-1500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */90
      ],
      /* scale */1.0
    ],
    React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center"
          }
        }, React.createElement("img", {
              style: {
                height: "250px"
              },
              src: logo_redux
            }), React.createElement("img", {
              style: {
                height: "250px"
              },
              src: logo_flow
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */-1500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */90
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Why do we need Reason?"), React.createElement("p", {
              style: {
                opacity: "0"
              }
            }, "ReactJS was a stepping stone to Reason."), React.createElement("p", {
              className: "source",
              style: {
                marginBottom: "0",
                opacity: "0"
              }
            }, "sources: "), React.createElement("ul", {
              style: {
                marginTop: "0",
                opacity: "0"
              }
            }, React.createElement("li", undefined, React.createElement("a", {
                      href: "https://www.reactiflux.com/transcripts/cheng-lou/"
                    }, "reactiflux.com/transcripts/cheng-lou/")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://youtu.be/_0T5OSSzxms?t=32m10s"
                    }, "React Conf 2017 - Taming the Meta Language"))))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */-1500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */90
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Why do we need Reason?"), React.createElement("p", undefined, "ReactJS was a stepping stone to Reason."), React.createElement("p", {
              className: "source",
              style: {
                marginBottom: "0"
              }
            }, "sources: "), React.createElement("ul", {
              style: {
                marginTop: "0"
              }
            }, React.createElement("li", undefined, React.createElement("a", {
                      href: "https://www.reactiflux.com/transcripts/cheng-lou/"
                    }, "reactiflux.com/transcripts/cheng-lou/")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://youtu.be/_0T5OSSzxms?t=32m10s"
                    }, "React Conf 2017 - Taming the Meta Language"))))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */4000,
        /* y */-500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */0
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "What is Reason?"), React.createElement("p", {
              style: {
                opacity: "0"
              }
            }, "Reason is a new syntax for the OCaml language.*"), React.createElement("p", {
              style: {
                fontSize: "24px",
                opacity: "0"
              }
            }, "*not yet a complete definition"))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */4000,
        /* y */-500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */0
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "What is Reason?"), React.createElement("p", undefined, "Reason is a new syntax for the OCaml language.*"), React.createElement("p", {
              style: {
                fontSize: "24px"
              }
            }, "*not yet a complete definition"))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */5000,
        /* y */-500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */0
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "What is OCaml?"), React.createElement("p", {
              style: {
                opacity: "0"
              }
            }, "OCaml is a general purpose programming language with an emphasis on expressiveness and safety."), React.createElement("ul", {
              style: {
                marginTop: "0",
                opacity: "0"
              }
            }, React.createElement("li", undefined, "has an advanced type system that helps catch your mistakes without getting in your way"), React.createElement("li", undefined, "no runtime type errors after type checking")), React.createElement("p", {
              className: "source",
              style: {
                margin: "0",
                opacity: "0"
              }
            }, "sources: "), React.createElement("ul", {
              style: {
                marginTop: "0",
                opacity: "0"
              }
            }, React.createElement("li", undefined, React.createElement("a", {
                      href: "http://ocaml.org/learn/description.html",
                      target: "_blank"
                    }, "ocaml.org/learn/description.html")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://bucklescript.github.io/bucklescript/Manual.html#_problems_of_javascript_how_bucklescript_solves_them",
                      target: "_blank"
                    }, "bucklescript.github.io/bucklescript/Manual.html"))))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */5000,
        /* y */-500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */0
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "What is OCaml?"), React.createElement("p", undefined, "OCaml is a general purpose programming language with an emphasis on expressiveness and safety."), React.createElement("ul", {
              style: {
                marginTop: "0"
              }
            }, React.createElement("li", undefined, "has an advanced type system that helps catch your mistakes without getting in your way"), React.createElement("li", undefined, "no runtime type errors after type checking")), React.createElement("p", {
              className: "source",
              style: {
                margin: "0"
              }
            }, "sources: "), React.createElement("ul", {
              style: {
                marginTop: "0"
              }
            }, React.createElement("li", undefined, React.createElement("a", {
                      href: "http://ocaml.org/learn/description.html",
                      target: "_blank"
                    }, "ocaml.org/learn/description.html")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://bucklescript.github.io/bucklescript/Manual.html#_problems_of_javascript_how_bucklescript_solves_them",
                      target: "_blank"
                    }, "bucklescript.github.io/bucklescript/Manual.html"))))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */5000,
        /* y */-500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */0
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "If OCaml is so great, why is no one using it?"), React.createElement("img", {
              style: {
                width: "100%"
              },
              src: why
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */5000,
        /* y */500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */180
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Welcome to Reason"), React.createElement("p", undefined, "Reason's new syntax is meant to be welcoming to JavaScript developers."), React.createElement("p", undefined, "Reason's toolchain makes it easy to get started."))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */4000,
        /* y */500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */180
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          src: reach
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */180
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("img", {
              src: bucklescript
            }), React.createElement("a", {
              style: {
                display: "block",
                textAlign: "center"
              },
              href: "https://reasonml.github.io/try/?reason=DYUwLgBA5gTi4EsB2UJIIYFsQQLwD4IAiACQWIgD00sQBuAKAYCkBnAOmAHtUAKWeGGSoiAJRDoAxmGYBlCACEurMFyREAlHSA",
              target: "_blank"
            }, "https://reasonml.github.io/try"))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */180
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            transform: "translate(1100px, 243px) scale(4)"
          },
          src: bucklescript
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */180
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            transform: "translate(-460px, 243px) scale(4)"
          },
          src: bucklescript
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */500,
        /* z */0
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", {
          style: {
            backgroundColor: "#db4d3f",
            padding: "30px",
            width: "50%"
          }
        }, React.createElement("img", {
              src: logo_reasonreact
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", {
          className: "center"
        }, React.createElement("p", undefined, "50% of messenger.com's UI Components have been converted to Reason"), React.createElement("img", {
              src: converted
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Facebook is investing in Reason"), React.createElement("ul", undefined, React.createElement("li", undefined, "new syntax version estimated to ship soon"), React.createElement("li", undefined, "it will look even more like JavaScript"), React.createElement("li", undefined, "automated upgrade script will convert codebase to the new syntax")))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          src: interop
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            transform: "translate(802px, 211px) scale(3.25)"
          },
          src: interop
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */3000,
        /* y */500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            transform: "translate(-460px, 243px) scale(4)"
          },
          src: interop
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */4000,
        /* y */-1500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "80%"
          },
          src: moment
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */5000,
        /* y */-1500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "80%"
          },
          src: naive
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */5000,
        /* y */-1500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "80%"
          },
          src: head
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */5000,
        /* y */-1500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "80%"
          },
          src: pairs
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */5000,
        /* y */-1500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "80%"
          },
          src: win
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */6000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Let's get started with Reason"), React.createElement("img", {
              src: bsb
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */6000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Editor Integration"), React.createElement("img", {
              src: editor
            }), React.createElement("a", {
              href: "https://blog.behrends.io/how-to-setup-reasonml-for-a-react-native-project-8c51f1cc1d34",
              target: "_blank"
            }, "Reason & React Native"), React.createElement("br", undefined), React.createElement("a", {
              href: "https://reasonml.github.io/guide/editor-tools/global-installation",
              target: "_blank"
            }, "Editor integration"))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */6000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Project template options"), React.createElement("img", {
              src: options
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */7000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", {
              style: {
                textAlign: "center"
              }
            }, "Create React App"), ReasonReact.element(/* None */0, /* None */0, CreateReactApp.make("Welcome to React and Reason", /* array */[])))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */7000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: cra_css
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */7000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: cra_logo
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */7000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: cra_component
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */7000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: cra_make
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */7000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: cra_render
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */7000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: cra_string
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */7000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: cra
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */8000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", {
              style: {
                textAlign: "center"
              }
            }, "Simple Video Player Example"), ReasonReact.element(/* None */0, /* None */0, VideoPlayer.make(/* array */[])))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_action_state_component
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_ref
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_make
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_initialState
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_reducer
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_reducer_switch
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_reducer_if
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_reducer_ref
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_reducer_state
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: reducer_options
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_render
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("img", {
          style: {
            width: "100%"
          },
          src: vp_action_ref
        })
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "WithRetainedProps"), React.createElement("img", {
              style: {
                width: "100%"
              },
              src: retained_type
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "WithRetainedProps"), React.createElement("img", {
              style: {
                width: "100%"
              },
              src: retained_component
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "WithRetainedProps"), React.createElement("img", {
              style: {
                width: "100%"
              },
              src: retained_prop
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "WithRetainedProps"), React.createElement("img", {
              style: {
                width: "100%"
              },
              src: retained_didMount
            }))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */9000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "So, why do we need Reason?"), React.createElement("p", undefined, "Reason is a lot more maintainable that what we're doing today."), React.createElement("p", undefined, "Elm is pretty awesome too."))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */10000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Resources"), React.createElement("p", undefined, "These talks have helped me to get started with Reason/ML."), React.createElement("ul", undefined, React.createElement("li", undefined, React.createElement("a", {
                      href: "https://youtu.be/vTb8UU_Yjmk",
                      target: "_blank"
                    }, "Jared Forsyth - Reason: JavaScript-flavored OCaml")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://youtu.be/L0xz-ILKsLE",
                      target: "_blank"
                    }, "Jacob Bass - Universal Reason")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://youtu.be/j5mlMUzpE5g",
                      target: "_blank"
                    }, "Keira Hodgkison - The Why and How of ReasonML")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://youtu.be/-J8YyfrSwTk",
                      target: "_blank"
                    }, "Yaron Minsky - Effective ML")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://youtu.be/IcgmSRJHu_8",
                      target: "_blank"
                    }, "Richard Feldman - Making Impossible States Impossible")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://youtu.be/XpDsk374LDE",
                      target: "_blank"
                    }, "Evan Czaplicki - The life of a file")), React.createElement("li", undefined, React.createElement("a", {
                      href: "https://youtu.be/oYk8CKH7OhE",
                      target: "_blank"
                    }, "Evan Czaplicki - Let's be mainstream!"))))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */11000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Thank you"), React.createElement("p", undefined, "Sincere thank you to everyone on the ", React.createElement("a", {
                  href: "https://discord.gg/reasonml",
                  target: "_blank"
                }, "Discord channel"), " for helping so many people get started with Reason."), React.createElement("p", undefined, "Please join the community today!"), React.createElement("p", undefined, React.createElement("a", {
                  href: "https://discord.gg/reasonml",
                  target: "_blank"
                }, "discord.gg/reasonml")), React.createElement("p", undefined, "Big thank you to ReactJS Boston for having me."), React.createElement("p", undefined, "Thank you for listening!"))
  ],
  /* tuple */[
    /* record */[
      /* translate : record */[
        /* x */11000,
        /* y */-2500,
        /* z */-10000
      ],
      /* rotate : record */[
        /* x */0,
        /* y */0,
        /* z */1080
      ],
      /* scale */1.0
    ],
    React.createElement("div", undefined, React.createElement("h1", undefined, "Medium.com tutorial"), React.createElement("img", {
              style: {
                width: "100%"
              },
              src: medium
            }), React.createElement("a", {
              href: "https://medium.com/@RRafatpanah/a-journey-to-reason-c408a87a54de",
              target: "_blank"
            }, "Link"))
  ]
];

ReactDOMRe.renderToElementWithId(ReasonReact.element(/* None */0, /* None */0, App.make(slides, config, /* array */[])), "root");

exports.logo_precisioneffect      = logo_precisioneffect;
exports.logo_reason               = logo_reason;
exports.maintainability           = maintainability;
exports.logo_react                = logo_react;
exports.logo_redux                = logo_redux;
exports.logo_flow                 = logo_flow;
exports.why                       = why;
exports.reach                     = reach;
exports.bucklescript              = bucklescript;
exports.logo_reasonreact          = logo_reasonreact;
exports.converted                 = converted;
exports.interop                   = interop;
exports.moment                    = moment;
exports.naive                     = naive;
exports.head                      = head;
exports.pairs                     = pairs;
exports.win                       = win;
exports.bsb                       = bsb;
exports.options                   = options;
exports.editor                    = editor;
exports.cra                       = cra;
exports.cra_css                   = cra_css;
exports.cra_logo                  = cra_logo;
exports.cra_component             = cra_component;
exports.cra_make                  = cra_make;
exports.cra_render                = cra_render;
exports.cra_string                = cra_string;
exports.vp_action_state_component = vp_action_state_component;
exports.vp_ref                    = vp_ref;
exports.vp_make                   = vp_make;
exports.vp_initialState           = vp_initialState;
exports.vp_reducer                = vp_reducer;
exports.vp_reducer_switch         = vp_reducer_switch;
exports.vp_reducer_if             = vp_reducer_if;
exports.vp_reducer_ref            = vp_reducer_ref;
exports.vp_reducer_state          = vp_reducer_state;
exports.vp_render                 = vp_render;
exports.vp_action_ref             = vp_action_ref;
exports.retained                  = retained;
exports.retained_type             = retained_type;
exports.retained_component        = retained_component;
exports.retained_prop             = retained_prop;
exports.retained_didMount         = retained_didMount;
exports.reducer_options           = reducer_options;
exports.medium                    = medium;
exports.config                    = config;
exports.s                         = s;
exports.slides                    = slides;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/index.re
// module id = 17
// module chunks = 0